import { render, staticRenderFns } from "./Side-Bar.vue?vue&type=template&id=074bdc67&scoped=true&"
import script from "./Side-Bar.vue?vue&type=script&lang=js&"
export * from "./Side-Bar.vue?vue&type=script&lang=js&"
import style0 from "./Side-Bar.vue?vue&type=style&index=0&id=074bdc67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074bdc67",
  null
  
)

export default component.exports